import { render, staticRenderFns } from "./joker.vue?vue&type=template&id=90f4a8ee&scoped=true"
import script from "./joker.vue?vue&type=script&lang=js"
export * from "./joker.vue?vue&type=script&lang=js"
import style0 from "./joker.vue?vue&type=style&index=0&id=90f4a8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f4a8ee",
  null
  
)

export default component.exports